export default "__VITE_ASSET__025174fa__"